import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LaundryIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LaundryIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.49266 16.0625C7.16907 16.0625 6.90672 16.3249 6.90672 16.6485V19.0703C6.90672 19.3939 7.16906 19.6563 7.49266 19.6563C7.81626 19.6563 8.0786 19.3939 8.0786 19.0703V16.6485C8.0786 16.3249 7.81626 16.0625 7.49266 16.0625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.83642 16.0625C9.51283 16.0625 9.25048 16.3249 9.25048 16.6485V19.0703C9.25048 19.3939 9.51282 19.6563 9.83642 19.6563C10.16 19.6563 10.4224 19.3939 10.4224 19.0703V16.6485C10.4224 16.3249 10.16 16.0625 9.83642 16.0625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.1802 16.0625C11.8566 16.0625 11.5942 16.3249 11.5942 16.6485V19.0703C11.5942 19.3939 11.8566 19.6563 12.1802 19.6563C12.5038 19.6563 12.7661 19.3939 12.7661 19.0703V16.6485C12.7661 16.3249 12.5038 16.0625 12.1802 16.0625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.5239 16.0625C14.2003 16.0625 13.938 16.3249 13.938 16.6485V19.0703C13.938 19.3939 14.2003 19.6563 14.5239 19.6563C14.8475 19.6563 15.1099 19.3939 15.1099 19.0703V16.6485C15.1099 16.3249 14.8475 16.0625 14.5239 16.0625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.8677 16.0625C16.5441 16.0625 16.2817 16.3249 16.2817 16.6485V19.0703C16.2817 19.3939 16.5441 19.6563 16.8677 19.6563C17.1913 19.6563 17.4536 19.3939 17.4536 19.0703V16.6485C17.4536 16.3249 17.1913 16.0625 16.8677 16.0625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4224 11.375H20.4085C20.7976 10.8693 21.0083 10.2585 21.0083 9.61719C21.0083 7.99754 19.6593 6.6875 18.0396 6.6875H18.038C18.4066 6.1975 18.6255 5.58871 18.6255 4.92969C18.6255 3.31426 17.3112 2 15.6958 2H8.66455C7.04912 2 5.73486 3.31426 5.73486 4.92969C5.73486 5.58871 5.95373 6.1975 6.3224 6.6875H6.3208C4.70111 6.6875 3.35205 7.99746 3.35205 9.61719C3.35205 10.2586 3.56275 10.8693 3.95178 11.375H3.93799C2.96873 11.375 2.18018 12.1636 2.18018 13.1328C2.18018 13.9259 2.70827 14.5977 3.4312 14.8158L4.40206 20.4749C4.51698 21.3313 5.29644 22 6.18343 22H18.1769C19.0639 22 19.8434 21.3313 19.9583 20.4749L20.9292 14.8158C21.6521 14.5977 22.1802 13.9259 22.1802 13.1328C22.1802 12.1635 21.3916 11.375 20.4224 11.375ZM8.66454 3.17186H15.6958C16.6651 3.17186 17.4536 3.96042 17.4536 4.92967C17.4536 5.89892 16.665 6.68748 15.6958 6.68748H8.66454C7.69528 6.68748 6.90673 5.89892 6.90673 4.92967C6.90673 3.96042 7.69529 3.17186 8.66454 3.17186ZM6.32079 7.85937H18.0396C19.0136 7.85937 19.8364 8.66433 19.8364 9.61718C19.8364 10.57 19.0136 11.375 18.0396 11.375H6.32079C5.34677 11.375 4.52391 10.57 4.52391 9.61718C4.52391 8.66437 5.34676 7.85937 6.32079 7.85937ZM18.8013 20.2885C18.7998 20.2972 18.7985 20.306 18.7974 20.3149C18.762 20.5979 18.4837 20.8281 18.1769 20.8281H6.1834C5.87664 20.8281 5.59828 20.5979 5.56293 20.3149C5.56184 20.306 5.56051 20.2972 5.55902 20.2885L4.63296 14.8906H19.7274L18.8013 20.2885ZM20.4224 13.7188H3.93797C3.61488 13.7188 3.35203 13.4559 3.35203 13.1328C3.35203 12.8097 3.61488 12.5469 3.93797 12.5469H20.4224C20.7455 12.5469 21.0083 12.8097 21.0083 13.1328C21.0083 13.4559 20.7455 13.7188 20.4224 13.7188Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0395 9.03125H6.32079C5.9972 9.03125 5.73485 9.29359 5.73485 9.61719C5.73485 9.94079 5.99719 10.2031 6.32079 10.2031H18.0396C18.3631 10.2031 18.6255 9.94079 18.6255 9.61719C18.6255 9.29359 18.3631 9.03125 18.0395 9.03125Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.6958 4.34374H8.66454C8.34095 4.34374 8.0786 4.60608 8.0786 4.92968C8.0786 5.25328 8.34094 5.51562 8.66454 5.51562H15.6958C16.0194 5.51562 16.2817 5.25328 16.2817 4.92968C16.2817 4.60608 16.0194 4.34374 15.6958 4.34374Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LaundryIcon;
